import { FaTwitter, FaFacebookF, FaLinkedinIn, FaGithub, FaInstagram } from "react-icons/fa";
import React from "react";
import logoImage from "../assets/Best_IT_Tranning_Near_Me.png"; // Adjust the path as necessary

const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white pt-12 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-8">
        {/*
          Key Change:
          - sm:grid-cols-2: On small screens (like iPad/iPad Mini portrait),
            it will switch to 2 columns instead of jumping straight to 4.
          - lg:grid-cols-4: On larger screens (desktops), it will be 4 columns.
          - gap-8: Increased gap for better spacing between columns.
          - pb-8: Added bottom padding to the main grid container.
        */}

        {/* Column 1: Brand */}
        <div>
          <a href="https://nvassistant.com" target="_blank" rel="noopener noreferrer">
            <img
              src={logoImage}
              alt="Nadezhda Venture Pvt. Ltd. Logo"
              className="h-12 mb-4" // You might want to adjust logo height responsiveness if needed
            />
          </a>
          <p className="text-sm leading-relaxed pr-4"> {/* Added pr-4 for right padding to prevent text from touching next column */}
            Nadezhda Venture Pvt. Ltd. : Your fast-growing IT and Digital Marketing partner.
            We deliver innovative solutions to propel your business forward with
            cutting-edge technology.
          </p>
          {/* Social Icons */}
          <div className="flex space-x-4 mt-4">
            <a href="https://www.instagram.com/nadezhda.vpl/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
              <FaInstagram size={20} />
            </a>
            <a href="https://facebook.com/nadezhdaventures/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
              <FaFacebookF size={20} />
            </a>
            <a href="https://linkedin.com/in/nv-assistant-1833b1287" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
              <FaLinkedinIn size={20} />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
              <FaGithub size={20} />
            </a>
          </div>
        </div>

        {/* Column 2: Services */}
        <div>
          <h3 className="text-white text-lg font-bold mb-2 border-b border-orange-600 inline-block pb-1">Services</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/Custom_Web_Development_In_Noida" className="hover:text-white transition-colors duration-200">Custom Web Development</a></li> {/* Added example links */}
            <li><a href="/Shopify_Web_Development_In_Noida" className="hover:text-white transition-colors duration-200">Shopify Development</a></li>
            <li><a href="/Wordpress_Web_Development_In_Noida" className="hover:text-white transition-colors duration-200">WordPress Development</a></li>
            <li><a href="/Flutter_App_Development_In_Noida" className="hover:text-white transition-colors duration-200">Flutter App Development</a></li>
            <li><a href="/Ios-App-Development_In_Noida" className="hover:text-white transition-colors duration-200">Android / iOS Apps</a></li>
           
          </ul>
        </div>

        {/* Column 3: Company */}
        <div>
          <h3 className="text-white text-lg font-bold mb-2 border-b border-orange-600 inline-block pb-1">Company</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href="/About_Us" className="hover:text-white transition-colors duration-200">About Us</a>
            </li>
            <li>
              <a href="/Virtual_Assistant_In_Noida" className="hover:text-white transition-colors duration-200">Virtual Staffing</a>
            </li>
            <li>
              <a href="/It_Outsourse_Tranning_In_Noida" className="hover:text-white transition-colors duration-200">IT Services</a> {/* Changed to more general IT Services, assuming this page exists */}
            </li>
           
            <li>
              <a href="/Placement_In_Noida" className="hover:text-white transition-colors duration-200">Placement</a>
            </li>
            <li>
              <a href="/contact" className="hover:text-white transition-colors duration-200">Contact Us</a> {/* Added Contact Us */}
            </li>
          </ul>
        </div>

        {/* Column 4: Newsletter */}
        <div>
          <h3 className="text-white text-lg font-bold mb-2 border-b border-orange-600 inline-block pb-1">Newsletter</h3>
          <p className="text-sm mt-4 mb-2">Subscribe to our newsletter</p>
          <form className="flex flex-col sm:flex-row gap-2"> {/* Made form responsive for stacking on smaller screens */}
            <input
              type="email"
              placeholder="Enter your email"
              className="p-2 rounded-lg text-black w-full flex-1 focus:ring-2 focus:ring-orange-500 focus:outline-none" // Added focus styles
            />
            <button
              type="submit"
              className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 w-full sm:w-auto" // Made button full width on small screens
            >
              Subscribe
            </button>

          </form>
        </div>
      </div>

      

      {/* Bottom Bar */}
      <div className="bg-white border-t border-gray-300 py-4 text-sm text-center text-gray-700">
        <p className="mb-2"> {/* Added mb-2 for spacing below the copyright */}
          <span className="text-orange-600 font-semibold">
            Nadezhda Venture Pvt. Ltd.
          </span>{' '}
          &copy; 2018-2025 | All rights reserved
        </p>
        <div className="flex flex-wrap justify-center space-x-4 sm:space-x-6 px-4"> {/* Used flex-wrap and adjusted spacing */}
          <a href="/terms-conditions" className="hover:text-orange-500 underline transition-colors duration-200"> {/* Added specific links */}
            Terms & Conditions
          </a>
          <a href="/privacy-policy" className="hover:text-orange-500 underline transition-colors duration-200">
            Privacy Policy
          </a>
          {/* <a href="/sitemap" className="hover:text-orange-500 underline transition-colors duration-200">
            Sitemap
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;